module.exports = __webpack_public_path__ + "static/media/halfCircleLightGreen3.4b45be3f.svg";